import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ACQUISITION_BACKEND_OLD, authTokenKey } from '@/constants';
import i18n from '@/translations/client-setup';
import { authStorage } from '@/classes/SylndrStorage';

// Define our single API slice object

export const faqsApiSlice = createApi({
    reducerPath: 'faqs',
    baseQuery: fetchBaseQuery({
        baseUrl: ACQUISITION_BACKEND_OLD,
        prepareHeaders: headers => {
            headers.set('lang', `${i18n.language}`);
            headers.set('origin', 'sylndr.com');
            headers.set('referer', 'sylndr.com');
            headers.set('Authority', 'sylndr.com');
            const userToken = authStorage.getItem(authTokenKey);
            if (userToken) headers.set('Authorization', `Bearer ${userToken}`);
            return headers;
        },
    }),
    tagTypes: [],
    endpoints: builder => ({
        getFAQs: builder.query<any, string>({
            query: lang => `faqs/${lang}`,
        }),
    }),
});

// Export the auto-generated hooks
export const { useGetFAQsQuery } = faqsApiSlice;
